import styled from 'styled-components'

export const ToolCallContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`

export const ToolCallBox = styled.div`
  position: relative;
  background: #f9fafb;
  border-radius: 8px;
  padding: 10px 15px;
  margin: 5px 0;
  font-size: 15px;
  color: #333;
  font-weight: 500;
  width: 100%;
`

export const ToolCallTag = styled.div<{ $variant?: 'active' | 'done' }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  margin: 0 4px 4px 0;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: ${({ $variant }) => ($variant === 'active' ? '#fff7e6' : '#f0fdf4')};
  color: ${({ $variant }) => ($variant === 'active' ? '#92400e' : '#166534')};
  font-size: 12px;
  font-weight: 500;
  max-width: 100%;
  word-break: break-all;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: ${({ $variant, theme }) =>
      $variant === 'active' ? theme.colors.primary : '#22c55e'};
  }
`

/* ---------- TIPOS ---------- */

export type ToolInvocationState = 'partial-call' | 'call' | 'result'

export interface ToolInvocation {
  toolCallId: string
  toolName: string
  state: ToolInvocationState
  args?: unknown
  result?: unknown
}

export interface ToolInvocationUIPart {
  type: 'tool-invocation'
  toolInvocation: ToolInvocation
}
